import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'
import { getMTODeliveryDate } from '@components/product/mto/helpers'

type FulfillmentConfig = {
  dispatchDays: number
  labelPrefix: string
}

type FulfillmentInfoProps = {
  createdAt?: string
  fulfillment: FulfillmentConfig
  classes?: string
}

export function getFulfillmentConfig({
  isMTO,
  isBundle
}: {
  isMTO: boolean
  isBundle: boolean
}): FulfillmentConfig | null {
  if (!isMTO) return null

  if (isBundle) {
    return {
      dispatchDays: 28,
      labelPrefix: 'Sold as full bundle, dispatch by'
    }
  }

  return {
    dispatchDays: 21,
    labelPrefix: 'Estimated dispatch by'
  }
}

function FulfillmentInfo({
  createdAt,
  fulfillment,
  classes
}: FulfillmentInfoProps) {
  return (
    <p className={classNames(styles.mtoDispatch__info, classes)}>
      <strong className={styles.mtoDispatch__title}>Made to Order:</strong>{' '}
      {fulfillment.labelPrefix}{' '}
      {getMTODeliveryDate(createdAt, fulfillment.dispatchDays)}
    </p>
  )
}

export default FulfillmentInfo
